function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var NavalBattleTemplate = require('./naval-battle.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var NavalBattleOverlay = /*#__PURE__*/function () {
  function NavalBattleOverlay(app, mod) {
    _classCallCheck(this, NavalBattleOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(NavalBattleOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.pushHudUnderOverlay();
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "renderFortification",
    value: function renderFortification() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.naval-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/fortification.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('A Naval Battle imminent in ' + this.mod.returnSpaceName(res.spacekey) + ': Fortification?');
    }
  }, {
    key: "renderPostNavalBattle",
    value: function renderPostNavalBattle() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.naval-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/naval_battle.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Naval Battle over in ' + this.mod.returnSpaceName(res.spacekey));
    }
  }, {
    key: "renderNavalBattle",
    value: function renderNavalBattle() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.naval-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/naval_battle.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Naval Battle in ' + this.mod.returnSpaceName(res.spacekey));
    }
  }, {
    key: "renderPreNavalBattle",
    value: function renderPreNavalBattle() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res, 1);
      var obj = document.querySelector('.naval-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/naval_battle.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Naval Battle imminent in ' + this.mod.returnSpaceName(res.spacekey));
    }
  }, {
    key: "assignHits",
    value: function assignHits() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var faction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hits_to_assign = res.attacker_hits;
      if (this.mod.returnPlayerCommandingFaction(faction) === this.mod.returnPlayerCommandingFaction(res.attacker_faction)) {
        hits_to_assign = res.defender_hits;
      }
      this.assignHitsManually(res, faction, hits_to_assign);
    }
  }, {
    key: "assignHitsManually",
    value: function assignHitsManually() {
      var _this = this;
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var faction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hits_to_assign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var hits_assignable = 0;
      var hits_assigned = 0;
      var his_self = this.mod;
      var hitstext = ' Hits';
      var undestroyed_corsairs = 0;
      var undestroyed_squadrons = 0;
      if (hits_to_assign == 1) {
        hitstext = ' Hit';
      }
      var did_i_lose_and_need_to_assign_last_hit = false;
      if (this.mod.game.state.naval_battle.attacker_hits > this.mod.game.state.naval_battle.defender_hits && this.mod.returnControllingPower(faction) == this.mod.returnControllingPower(this.mod.game.state.naval_battle.defender_faction)) {
        did_i_lose_and_need_to_assign_last_hit = true;
      }
      if (this.mod.game.state.naval_battle.attacker_hits <= this.mod.game.state.naval_battle.defender_hits && this.mod.returnControllingPower(faction) == this.mod.returnControllingPower(this.mod.game.state.naval_battle.attacker_faction)) {
        did_i_lose_and_need_to_assign_last_hit = true;
      }
      this.updateInstructions("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> ").concat(hitstext, " (squadrons take 2 hits)"));
      this.mod.hud.updateStatus("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> ").concat(hitstext, " (squadrons take 2 hits)"));
      var qs1 = '.attacker .not-assignable';
      var qs2 = '.attacker .hits-assignable';
      if (this.mod.returnPlayerCommandingFaction(faction) === this.mod.returnPlayerCommandingFaction(res.defender_faction)) {
        qs1 = '.defender .not-assignable';
        qs2 = '.defender .hits-assignable';
      }
      document.querySelectorAll(qs1).forEach(function (el) {
        el.remove();
      });

      //
      // count undestroyed corsairs
      //
      document.querySelectorAll(qs2).forEach(function (el) {
        var unit_type = el.getAttribute('data-unit-type');
        var unit_owner = el.getAttribute('data-faction');
        if (unit_owner.indexOf(' / ')) {
          unit_owner = unit_owner.split(' / ')[0];
        }
        if (unit_type == 'corsair') {
          undestroyed_corsairs++;
        }
        if (unit_type == 'squadron') {
          undestroyed_squadrons++;
        }
      });
      document.querySelectorAll(qs2).forEach(function (el) {
        try {
          var unit_type = el.getAttribute('data-unit-type');
          var unit_owner = el.getAttribute('data-faction');
          var factionspace = unit_owner;
          if (unit_owner.indexOf(' / ')) {
            unit_owner = unit_owner.split(' / ')[0];
          }
          var can_i_kill_this_guy = false;
          if ((his_self.returnControllingPower(factionspace) === his_self.returnControllingPower(faction) || his_self.returnControllingPower(unit_owner) == his_self.returnControllingPower(faction)) && his_self.game.player === his_self.returnPlayerCommandingFaction(his_self.returnControllingPower(faction))) {
            can_i_kill_this_guy = true;
          }
          if (can_i_kill_this_guy) {
            if (factionspace) {
              var obj = el.querySelector('.naval-battle-desc');
              if (obj) {
                obj.innerHTML += ' (click to assign hit)';
              }
            }
            el.classList.add('hits-assignable-hover-effect');
            hits_assignable++;
            if (unit_type != 'corsair') {
              hits_assignable++;
            }
            el.onclick = function (e) {
              var hits_left = hits_to_assign - hits_assigned;
              console.log('hits left: ' + hits_left);
              console.log('hits to assign: ' + hits_to_assign);
              console.log('hits assigned: ' + hits_assigned);

              //
              // loser needs to assign the last hit
              //
              if (undestroyed_corsairs == 0 && undestroyed_squadrons > 0 && did_i_lose_and_need_to_assign_last_hit == true) {
                if (hits_left == 1) {
                  console.log('loser must assign last hit: hits_left increased to 2');
                  hits_left = 2;
                }
              }
              var this_unit_type = e.currentTarget.getAttribute('data-unit-type');
              if (hits_left > 1 && this_unit_type == 'corsair' && undestroyed_squadrons > 0) {
                alert('You must assign hits to Squadrons before Corsairs...');
                return;
              }
              if (hits_left == 1 && this_unit_type == 'squadron') {
                alert('You must assign your last hit to a Corsair...');
                return;
              }
              if (hits_left == 2 && this_unit_type == 'corsair') {
                if (undestroyed_corsairs <= 1 && undestroyed_squadrons > 0) {
                  alert('You must assign your last two hits to a Squadron...');
                  return;
                }
              }
              document.querySelectorAll('.hits_to_assign').forEach(function (el2) {
                el2.innerHTML = hits_left;
              });
              var unit_type = el.getAttribute('data-unit-type');
              var faction = el.getAttribute('data-faction');
              if (faction.indexOf(' / ') > 0) {
                faction = faction.split(' / ')[0];
              }
              var spacekey = res.spacekey;
              hits_assigned++;
              if (unit_type !== 'corsair') {
                hits_assigned++;
              }
              hits_left = hits_to_assign - hits_assigned;
              if (hits_left > 0) {
                _this.mod.hud.updateStatus("Assign <span class=\"hits_to_assign\">".concat(hits_left, "</span> Hits"));
              }
              el.remove();
              _this.mod.addMove('naval_battle_destroy_unit\t' + faction + '\t' + spacekey + '\t' + unit_type);

              //
              // loser needs to assign the last hit if squadron remains
              //
              if (undestroyed_squadrons > 1 && did_i_lose_and_need_to_assign_last_hit == true) {
                if (hits_left == 1) {
                  hits_left = 2;
                }
              }

              //
              // Ottoman may have corsairs which can be destroyed in 1 hit
              //
              if (hits_left == 0 || hits_assigned >= hits_to_assign || hits_assigned >= hits_assignable || undestroyed_corsairs == 0 && hits_left <= 1) {
                document.querySelectorAll('.hits-assignable').forEach(function (el3) {
                  el3.onclick = function (e) {};
                });
                _this.updateInstructions("Cannot Assign More Hits (squadrons take 2 hits to destroy) - close to continue");
                _this.mod.endTurn();
                return;
              }
            };
          }
        } catch (err) {
          console.log('#');
          console.log('#');
          console.log('# naval battle error? ' + JSON.stringify(err));
          console.log('#');
          console.log('#');
          alert('error assigning hits -- please check console.log: ' + JSON.stringify(err));
        }
      });
      if (hits_to_assign > hits_assignable) {
        hits_to_assign = hits_assignable;
        hits_left = hits_to_assign;
      }
      if (hits_assigned == hits_to_assign || hits_assigned >= hits_assignable || undestroyed_corsairs == 0 && hits_to_assign == 1 && hits_assignable % 2 == 0) {
        document.querySelectorAll('.hits-assignable').forEach(function (el) {
          el.onclick = function (e) {};
        });
        this.updateInstructions("Cannot Assign More Hits (squadrons take 2 hits to destroy) - close to continue");
        if (this.mod.game.player == this.mod.returnPlayerCommandingFaction(faction)) {
          this.mod.endTurn();
        }
        return;
      }
      if (faction != '') {
        if (this.mod.game.player == this.mod.returnPlayerCommandingFaction(faction)) {
          this.mod.hud.updateStatus("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> Hits"));
        } else {
          this.updateInstructions(this.mod.returnFactionName(faction) + ' Assigning Hits');
        }
      } else {
        this.updateInstructions('Assigning Hits');
      }
    }
  }, {
    key: "attackersWin",
    value: function attackersWin(res) {
      this.pushHudUnderOverlay();
      this.render(res, 0);
      var obj = document.querySelector('.naval-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/naval_battle.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Attackers Win - Close to Continue');
    }
  }, {
    key: "defendersWin",
    value: function defendersWin(res) {
      this.pushHudUnderOverlay();
      this.render(res, 0);
      var obj = document.querySelector('.naval-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/naval_battle.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Defenders Win - Close to Continue');
    }
  }, {
    key: "render",
    value: function render() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pre_battle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var am_i_attacker = false;
      var am_i_defender = false;
      if (this.mod.returnPlayerFactions(this.mod.game.player).includes(res.attacker_faction) || this.mod.returnPlayerCommandingFaction(res.attacker_faction) == this.mod.game.player) {
        am_i_attacker = true;
      }
      if (this.mod.returnPlayerFactions(this.mod.game.player).includes(res.defender_faction) || this.mod.returnPlayerCommandingFaction(res.defender_faction) == this.mod.game.player) {
        am_i_defender = true;
      }
      this.visible = true;
      this.overlay.show(NavalBattleTemplate());
      if (pre_battle == 1) {
        res.attacker_modified_rolls = res.attacker_results;
      }
      if (pre_battle == 1) {
        res.defender_modified_rolls = res.defender_results;
      }
      console.log('RES: ' + JSON.stringify(res));
      var modified_rolls_idx = 0;

      //
      // attacker units first!
      //
      for (var i = 0; i < res.attacker_units.length; i++) {
        var roll = res.attacker_modified_rolls[modified_rolls_idx];
        var unit_type = res.attacker_units[i];
        var faction_name = res.attacker_units_faction[i];
        var faction_owner = faction_name;
        if (res.attacker_units_owners.length > i) {
          faction_owner = res.attacker_units_owners[i];
        }
        if (res.attacker_units_owners.length <= i) {
          faction_owner = res.attacker_units_owners[res.attacker_units_owners.length - 1];
        }
        var how_many_hits = 1;
        if (unit_type === 'squadron') {
          how_many_hits = 2;
        }
        var assignable = '';
        if (am_i_attacker) {
          assignable = ' not-assignable';
        }
        if (['regular', 'mercenary', 'squadron', 'cavalry', 'corsair'].includes(unit_type)) {
          if (am_i_attacker) {
            assignable = ' hits-assignable';
          }
        }
        for (var z = 0; z < how_many_hits; z++) {
          var hit_number = '';
          if (z > 0) {
            modified_rolls_idx++;
            roll = res.attacker_modified_rolls[modified_rolls_idx];
            assignable = ' not-assignable';
            hit_number = ' (2nd shot)';
          }
          if (res.attacker_units_destroyed.includes(i)) {
            assignable = 'destroyed';
            faction_name = 'destroyed';
          }
          var rrclass = '';
          if (roll >= 5) {
            rrclass = 'hit';
          }
          if (pre_battle) {
            roll = '?';
            rrclass = '';
          }
          if (faction_owner != faction_name) {
            faction_name = faction_name + ' / ' + faction_owner;
          }
          var html = "\n              <div class=\"naval-battle-row ".concat(assignable, "\" data-unit-type=\"").concat(unit_type, "\" data-faction=\"").concat(faction_name, "\">\n                <div class=\"naval-battle-unit\">").concat(unit_type, "<div class=\"naval-battle-desc\">").concat(faction_name).concat(hit_number, "</div></div>\n                 \t<div class=\"naval-battle-roll ").concat(rrclass, "\">").concat(roll, "</div>\n                </div>\n          ");
          this.app.browser.addElementToSelector(html, '.naval-battle-grid .attacker');
        }
        modified_rolls_idx++;
      }
      while (modified_rolls_idx < res.attacker_modified_rolls.length) {
        var _faction_name = 'navy leader';
        var _unit_type = 'bonus';
        var _roll = res.attacker_modified_rolls[modified_rolls_idx];
        var _assignable = ' not-assignable';
        var _rrclass = '';
        if (_roll >= 5) {
          _rrclass = 'hit';
        }
        if (pre_battle) {
          _roll = '?';
          _rrclass = '';
        }
        var _html = "\n              <div class=\"naval-battle-row ".concat(_assignable, "\" data-unit-type=\"").concat(_unit_type, "\" data-faction=\"").concat(_faction_name, "\">\n                <div class=\"naval-battle-unit\">").concat(_unit_type, "<div class=\"naval-battle-desc\">").concat(_faction_name, "</div></div>\n                 \t<div class=\"naval-battle-roll ").concat(_rrclass, "\">").concat(_roll, "</div>\n                </div>\n          ");
        this.app.browser.addElementToSelector(_html, '.naval-battle-grid .attacker');
        modified_rolls_idx++;
      }

      //
      // defender next
      //
      modified_rolls_idx = 0;
      for (var _i = 0; _i < res.defender_units.length; _i++) {
        var _roll2 = res.defender_modified_rolls[modified_rolls_idx];
        var _unit_type2 = res.defender_units[_i];
        var _faction_name2 = res.defender_units_faction[_i];
        var _faction_owner = _faction_name2;
        if (res.defender_units_owners.length > _i) {
          _faction_owner = res.defender_units_owners[_i];
        }
        if (res.defender_units_owners.length <= _i) {
          _faction_owner = res.defender_units_owners[res.defender_units_owners.length - 1];
        }
        var _how_many_hits = 1;
        if (_unit_type2 === 'squadron') {
          _how_many_hits = 2;
        }
        var _assignable2 = '';
        if (am_i_defender) {
          _assignable2 = ' not-assignable';
        }
        if (['regular', 'mercenary', 'squadron', 'cavalry', 'corsair'].includes(_unit_type2)) {
          if (am_i_defender) {
            _assignable2 = ' hits-assignable';
          }
        }
        for (var _z = 0; _z < _how_many_hits; _z++) {
          var _hit_number = '';
          if (_z > 0) {
            modified_rolls_idx++;
            _roll2 = res.defender_modified_rolls[modified_rolls_idx];
            _assignable2 = ' not-assignable';
            _hit_number = ' (2nd shot)';
          }
          if (res.defender_units_destroyed.includes(_i)) {
            _assignable2 = 'destroyed';
            _faction_name2 = 'destroyed';
          }
          var _rrclass2 = '';
          if (_roll2 >= 5) {
            _rrclass2 = 'hit';
          }
          if (pre_battle) {
            _roll2 = '?';
            _rrclass2 = '';
          }
          if (_faction_owner != _faction_name2) {
            _faction_name2 = _faction_name2 + ' / ' + _faction_owner;
          }
          var _html2 = "\n              <div class=\"naval-battle-row ".concat(_assignable2, "\" data-unit-type=\"").concat(_unit_type2, "\" data-faction=\"").concat(_faction_name2, "\">\n                <div class=\"naval-battle-unit\">").concat(_unit_type2, "<div class=\"naval-battle-desc\">").concat(_faction_name2).concat(_hit_number, "</div></div>\n                 \t<div class=\"naval-battle-roll ").concat(_rrclass2, "\">").concat(_roll2, "</div>\n                </div>\n            ");
          this.app.browser.addElementToSelector(_html2, '.naval-battle-grid .defender');
        }
        modified_rolls_idx++;
      }
      while (modified_rolls_idx < res.defender_modified_rolls.length) {
        var _faction_name3 = 'navy leader';
        var _unit_type3 = 'bonus';
        var _roll3 = res.defender_modified_rolls[modified_rolls_idx];
        var _assignable3 = ' not-assignable';
        var _rrclass3 = '';
        if (_roll3 >= 5) {
          _rrclass3 = 'hit';
        }
        if (pre_battle) {
          _roll3 = '?';
          _rrclass3 = '';
        }
        var _html3 = "\n              <div class=\"naval-battle-row ".concat(_assignable3, "\" data-unit-type=\"").concat(_unit_type3, "\" data-faction=\"").concat(_faction_name3, "\">\n                <div class=\"naval-battle-unit\">").concat(_unit_type3, "<div class=\"naval-battle-desc\">").concat(_faction_name3, "</div></div>\n                 \t<div class=\"naval-battle-roll ").concat(_rrclass3, "\">").concat(_roll3, "</div>\n                </div>\n          ");
        this.app.browser.addElementToSelector(_html3, '.naval-battle-grid .defender');
        modified_rolls_idx++;
      }
      this.attachEvents();
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions() {
      var help = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var x = document.querySelector('.naval-battle-overlay .help');
      if (x) {
        x.innerHTML = help;
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "showNavalBattleResults",
    value: function showNavalBattleResults(obj) {}
  }]);
}();
module.exports = NavalBattleOverlay;